import React from 'react';
import { ArrowRight } from 'lucide-react';
const points = [{
  num: '01',
  emoji: '😩',
  title: 'Llegas a la clase sin saber exactamente qué vas a dar.',
  desc: 'Improvisas sobre la marcha y las alumnas notan que no hay un plan claro detrás.',
  feeling: 'Inseguridad'
}, {
  num: '02',
  emoji: '📉',
  title: 'Tus alumnas no progresan visiblemente.',
  desc: 'No tienes una secuencia clara de nivel a nivel y muchas abandonan antes de los 3 meses.',
  feeling: 'Frustración'
}, {
  num: '03',
  emoji: '🔄',
  title: 'Siempre los mismos 10 o 15 ejercicios.',
  desc: 'Repites lo mismo porque no tienes más material listo, y las alumnas se aburren.',
  feeling: 'Estancamiento'
}, {
  num: '04',
  emoji: '👥',
  title: 'Grupos con niveles mezclados = caos.',
  desc: 'No sabes cómo adaptar el mismo ejercicio para principiantes y avanzadas en la misma clase.',
  feeling: 'Agobio'
}, {
  num: '05',
  emoji: '😨',
  title: 'Alumnas con lesiones o condiciones especiales.',
  desc: 'Sientes inseguridad técnica al trabajar con hernias, embarazo o adultos mayores.',
  feeling: 'Miedo'
}, {
  num: '06',
  emoji: '💼',
  title: 'Quieres que te reconozcan como profesional.',
  desc: 'Buscas ofrecer un sistema serio y moderno — no clases improvisadas que no justifican lo que cobras.',
  feeling: 'Aspiración'
}];
export function ForWhomSection() {
  return <section className="w-full bg-bg-dark py-16 sm:py-24 px-4 relative overflow-hidden" data-id="element-182">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-primary/10 rounded-full blur-[100px] pointer-events-none" data-id="element-183"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-secondary/8 rounded-full blur-[100px] pointer-events-none" data-id="element-184"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-185">
        <div className="text-center mb-10 sm:mb-12" data-id="element-186">
          <p className="inline-block bg-primary/10 text-primary font-bold uppercase tracking-wider text-[11px] sm:text-xs px-3 py-1.5 rounded-full border border-primary/20 mb-4" data-id="element-187">
            👀 Esto es para ti si…
          </p>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-4 tracking-tight" data-id="element-188">
            ¿Te suena{' '}
            <span className="text-primary" data-id="element-189">alguna de estas escenas?</span>
          </h2>
          <p className="text-text-sec text-base sm:text-lg max-w-xl mx-auto" data-id="element-190">
            Si te identificas con{' '}
            <span className="text-text-main font-bold" data-id="element-191">2 o más</span>, MEGAPACK
            PILATES LISTO fue diseñado exactamente para ti.
          </p>
        </div>

        <div className="space-y-3 sm:space-y-4" data-id="element-192">
          {points.map((point, i) => <div key={i} className="flex items-start gap-4 sm:gap-5 bg-bg-alt rounded-2xl p-5 sm:p-6 border border-border-light hover:border-primary/40 hover:-translate-y-0.5 hover:shadow-[0_12px_28px_-10px_rgba(139,111,191,0.25)] transition-all duration-300 group" data-id="element-193">
              <div className="flex flex-col items-center flex-shrink-0 gap-1.5" data-id="element-194">
                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-gradient-to-br from-primary/15 to-primary/5 border border-primary/25 flex items-center justify-center text-xl sm:text-2xl shadow-inner" data-id="element-195">
                  {point.emoji}
                </div>
                <span className="text-primary/70 font-black text-[10px] sm:text-xs leading-none" data-id="element-196">
                  {point.num}
                </span>
              </div>

              <div className="flex-1 min-w-0" data-id="element-197">
                <div className="flex flex-wrap items-center gap-2 mb-1.5" data-id="element-198">
                  <h3 className="text-text-main text-base sm:text-xl font-bold leading-snug" data-id="element-199">
                    {point.title}
                  </h3>
                  <span className="text-primary text-[10px] sm:text-xs font-bold uppercase tracking-wider bg-primary/10 px-2 py-0.5 rounded-full border border-primary/15" data-id="element-200">
                    {point.feeling}
                  </span>
                </div>
                <p className="text-text-sec text-sm sm:text-base font-medium leading-relaxed" data-id="element-201">
                  {point.desc}
                </p>
              </div>

              <div className="hidden sm:flex flex-shrink-0 items-center self-center" data-id="element-202">
                <div className="w-7 h-7 rounded-full border-2 border-border-light group-hover:border-cta-green group-hover:bg-cta-green/10 transition-colors flex items-center justify-center" data-id="element-203">
                  <span className="text-cta-green font-bold text-sm opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-204">
                    ✓
                  </span>
                </div>
              </div>
            </div>)}
        </div>

        <div className="mt-10 sm:mt-12 bg-gradient-to-br from-primary/10 via-bg-alt to-cta-green/[0.06] border border-primary/20 rounded-2xl p-6 sm:p-8 text-center relative overflow-hidden" data-id="element-205">
          <p className="text-text-main font-bold text-lg sm:text-xl mb-2" data-id="element-206">
            ✋ ¿Te reconociste en <span className="text-primary" data-id="element-207">2 o más</span>?
          </p>
          <p className="text-text-sec text-sm sm:text-base mb-5 sm:mb-6" data-id="element-208">
            Entonces este Kit fue hecho para ti. ¿Cuántas clases más vas a
            improvisar?
          </p>
          <a href="#pricing" className="inline-flex items-center justify-center gap-2 bg-cta-green hover:bg-cta-green-hover text-white font-black text-sm sm:text-base px-6 sm:px-8 py-3 sm:py-3.5 rounded-xl transition-all shadow-[0_10px_25px_-8px_rgba(15,139,111,0.5)]" data-id="element-209">
            Quiero el Megapack completo
            <ArrowRight className="w-4 h-4" data-id="element-210" />
          </a>
        </div>
      </div>
    </section>;
}